const Form053TC = {
    stepName: {
        importantNotes: "重要事項",
        information: "基本資料",
        SelectApplyType: "選擇甲部／乙部",
        SectionA: "甲部",
        SectionB: "乙部",
        CGHP: "宿舍家長現金津貼",
        certification: "確認",
    },
    title: {
        note: "註",
        noteTitle: "個人資料收集聲明",
        schoolInformation: "學校資料",
        CGHP: "宿舍家長現金津貼",
        selectMessage: "請選擇您需要的：",
        sectionACGHP: "甲部 以宿舍家長的空缺職位換取「津貼」",
        vacancyPeriod: "空缺凍結期(不得少於30天)",
        vacantPost: "空缺職位",
        indicateDocuments: "請註明以下文件：",
        sectionBCGHP:
            "乙部 以「津貼」代替宿舍家長放取不少於30天核准假期的臨時補缺人員安排",
        leaveInformation: "休假宿舍家長的資料",
        applyTitle: "請選擇所需津貼申請：",
    },
    label: {
        revokeOrNot: "請選擇",
        irrevocable: "不可撤回",
        revocable: "可撤回",
        revokOptions: {
            irrevocable: "不可撤回",
            revocable: "可撤回",
        },
        revokeRefLabel: "請填寫",
        termsConditions: "我已閱讀、理解並同意上述條款和條件。",
        statementTwo: "本人理解申請人和教師需要擁有「智方便+」帳戶才能處理申請。",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        month: "月份",
        year: "年份",
        situationOfCGHP: "宿舍家長現金津貼",
        from: "由",
        to: "至",
        schoolYear: "學年",
        houseparentTotalNumber: "a. 編制內宿舍家長的職位總數",
        irrevocableNumber: "b. 不可撤回的凍結宿舍家長空缺職位數目",
        irrevocableDate: "教育局批函發出日期",
        revocableNumber: "c.可撤回的凍結宿舍家長空缺職位數目",
        revocableDate: "教育局批函發出日期",
        attachment: "批准書",
        attachment1: "強積金供款證明資料",
        attachment2: "隨附(前次日期)的申領表格副本",
        vacantPercentage:
            "d. 宿舍家長空缺職位申領現金津貼的百分比率 [(b+c)/(a)*100%]",
        periodText: `本人欲申報資料如下：`,
        periodText1: `在`,
        periodText2: `學年，由`,
        periodText3: `至`,
        periodText4: `本校申領「宿舍家長現金津貼(「津貼」)的情況如下`,
        sectionACGHPText: "甲部：以宿舍家長的空缺職位換取「津貼」",
        sectionBCGHPText:
            "乙部：以「津貼」代替宿舍家長放取不少於30天核准假期的臨時補缺人員安排",
        sectionANote2: "(請在適當地方加上「√」號)",
        sectionANote3: "合資格月數",
        sectionANote4: "月薪",
        sectionANote5: "強積金供款津貼",
        sectionACGHPAmount: "「津貼」金額",
        irrevocableTotal: "總計(不可撤回)",
        revocableTotal: "總計(可撤回)",
        amountTotal: "總計(「津貼」金額)",
        claim: "新申領津貼的職位/修訂",
        claimOptions: {
            N: "新申領津貼的職位",
            R: "修訂",
        },
        previousClaim: "本學年已提交之申請表格",
        previousClaimOptions: {
            U: "不更改前次申領表格",
            D: "刪除前次申領表格",
            C: "更改前次申領表格",
        },
        applicationNumber: "請註明前次申領表格編號",
        applicationNumberErr: "申請編號",
        previousClaimDate: "前次申領表格日期",
        freezingFrom: "空缺凍結期由",
        freezingTo: "空缺凍結期至",
        datedAttached: "附上之前索賠的副本",
        remark: "評論",
        fileSize: "每個文件的最大大小為：5MB",
        fileType: "可接受的文件類型：PDF、JPEG、PNG",
        fileNum: "最大文件數：8",
        name: "姓名",
        SRN: "職員參考編號",
        post: "職位數量",
        leavePeriodFrom: "休假時期由",
        leavePeriodTo: "休假時期至",
        absenceReason: "缺勤原因",
        CGHPInformation: "「津貼」的資料",
        qualifiedPeriodFrom: "合資格時期由",
        qualifiedPeriodTo: "合資格時期至",
        qualifiedMonthNo: "合資格月數(a)",
        monthlySalary: "月薪(b)",
        MPFSubsidy: "強積金供款津貼(c)",
        sectionBCGHPAmount: "「津貼」金額 (d) = (a) * (b) + (c)",
        certify: "本人證實 –",
        freezingPeriod: "空缺凍結期",
        leavePeriod: "休假時期",
        contactPerson: "聯絡人",
        tel: "電話號碼",
        sSDO: "高級學校發展主任",
        sSDOValue: {
            0: "北區",
            1: "葵青區",
            2: "西貢區",
            3: "東區",
            4: "屯門區",
            5: "九龍城區",
            6: "觀塘區",
            7: "南區",
            8: "油尖旺區",
            9: "荃灣區",
            10: "沙田區",
            11: "深水埗區",
            12: "大埔區",
            13: "灣仔區",
            14: "離島區",
            15: "中西區",
            16: "元朗區",
            17: "黃大仙區",
        },
    },
    message: {
        exceedsHPposts: "已兌現的空缺HP職位的百分比超過40%的上限",
        toMessage: "致: 教育局經常津貼組",
        attnMessage: "[經辦人︰一級會計主任(經常津貼)]",
    },
    errorMsg: {
        least30Days: "休假日期少於30曆日，請重新選擇。",
        freezing30Days: "空缺凍結期必須為最少30曆日",
        E001: "只能是字母數字",
        E002: "合资格时期开始时间不能早于休假时期开始时间",
        maxDigitADecimal: "此項必須為最多{{maxDigit}}位數及小數位",
        afterDate: "請輸入{{date}}或之後的日期",
        noLeadingZero: "数字不能以0开头",
        afterAug31: "休假時期不能在該學年的八月三十一日之後",
        freezingToAfterAug31: "空缺凍結期不能在該學年的八月三十一日之後",
        qualifiedToAfterAug31: "合資格時期不能在該學年的八月三十一日之後",
        withinSchoolYear: "已超出學年範圍內",
        schoolYearFormat: "學年格式必須是“XXXX/YYYY”",
    },
    monthOption: {
        jan: "01",
        feb: "02",
        mar: "03",
        apr: "04",
        may: "05",
        jun: "06",
        jul: "07",
        aug: "08",
        sep: "09",
        oct: "10",
        nov: "11",
        dec: "12",
    },
    note: {
        note1:
            `1. 在事先取得大部分宿舍家長對現金津貼申領的同意及在宿舍服務質素不受負面影響的情況下，特殊學校最多可將每學年宿舍家長編制的20%空缺職位申領現金津貼。` +
            `如個別學校有意以多於編制內20%的宿舍家長空缺職位申領現金津貼，在作任何招聘額外員工的安排之前，必須事先取得教育局的批准。` +
            `如欲事先取得教育局批准，有關學校須向教育局特殊教育支援第一組(地址：香港添馬添美道2號政府總部東翼5樓)提交書面申請，並列明理據，以便考慮。` +
            `可撤回的凍結宿舍家長空缺職位的批准只適用於相關學年，至於不可撤回的凍結宿舍家長空缺職位的批准(包括在此通函生效日期前已取得的批准)，只要其獲批凍結及申領現金的宿舍家長職位數目等於或低於宿舍家長編制40%的申領上限，便適用於獲批的相關及往後學年。` +
            `假如宿舍家長的編制有所變動，以致在之前的學年內已獲批凍結及申領現金津貼的宿舍家長職位數目超逾該學年宿舍家長編制40%的申領上限，可凍結及申領現金津貼的宿舍家長職位數目將會下調至等於或低於該學年及往後學年宿舍家長編制40%的上限。` +
            `在任何情況下，宿舍家長空缺職位的現金津貼申領均不可超逾每學年宿舍家長編制的40%。` +
            `如以宿舍家長編制的20%或40%的現金津貼申領上限導致個別學校的宿舍家長職位數目出現小數，該小數將下調至最接近的整數。` +
            `在超逾每學年宿舍家長編制20%的空缺職位作現金津貼申領，學校向經常津貼組提交申領表格時，必須一併提交特殊教育支援第一組的有關批函。`,
        note2: `2. 不可撤回及可撤回的宿舍家長職位凍結及現金津貼的申請均須每年提交。學校須在有關學年內提交申領表格。`,
        note3: `3. 計算由起始日直至完結日(首尾兩天包括在內)的合資格申領「津貼」月數，包含以下三個元素：`,
        note4: `(i) 合資格日數在起始月份的曆日總數中所佔的比例(如適用)；`,
        note5: `(ii) 完整的曆月數(如適用)；以及`,
        note6: `(iii) 合資格日數在完結月份曆日總數中所佔的比例(如適用)。`,
        note7: `例如：`,
        note8: `假設合資格申領「津貼」的時期是由二月五日至五月二十六日，計算合資格月數的方法如下：`,
        note9: `(i) 在起始月份的合資格日數為24日(二月五日至二月二十八日)除以28日(二月份的曆日總數) = 0.857個月；`,
        note10: `(ii) 由三月至四月有兩個完整的曆月數；`,
        note11: `(iii) 完結月份的合資格日數為26日(五月一日至二十六日)除以31日(五月份的曆日總數) = 0.839個月；以及`,
        note12: `(iv) 合資格申領月數應為上述三個元素的總和(計算至三個小數位)，即0.857 + 2 + 0.839 = 3.696。`,
        note13: `4. 填寫宿舍家長職位的中點薪金，由二零一三/一四學年起，宿舍家長的中點薪金為總薪級表第16點。`,
        note14: `5. 如合資格申領期達60天或以上，強積金計劃僱主供款(月薪的5%，並以現行強積金規例所訂的最高金額為上限)將會包括在內。如宿舍家長休假少於60個曆日，而就其臨時補缺安排須向強積金供款，請提供證明資料。`,
        note15: `6. 填寫休假宿舍家長的職員參考編號。`,
        note16: `7. 請注意，學校必須按照教育局通告第1/2006號規定批假。`,
        note17: `(i) 本校已獲法團校董會/校董會及大多數宿舍家長同意，在本學年上述期間凍結甲部所載的宿舍家長職位；`,
        note18: `(ii) 凍結甲部所載的宿舍家長職位並申領「津貼」，是因為該(等)核准編制的職位在上述申領期間有空缺及此項申領符合「津貼」所列明的申領條件；`,
        note19: `(iii) 本校沒有就甲部和乙部所載的相同休假/空缺，向政府提出其他津貼的申請；以及本校將會把任何多收取的津貼退還教育局。`,
        note20: `申請人應仔細閱讀並同意`,
        note21: `關於私人數據的注意事項`,
        note22: `新：新申領津貼的職位／修訂：修訂申領(隨附(前次日期)的申領表格副本)`,

        note23: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        note24: "(a) 辦理與聘用有關的事宜；",
        note25: "(b) 處理發放薪金津貼，以及計算公積金的供款和贈款；",
        note26: "(c) 進行核數工作；",
        note27: "(d) 進行研究及統計資料，以便規劃教育服務；",
        note28: "(e) 處理有關教育專業人員發展的事宜；",
        note29: "(f) 執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",
        note30: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        note31: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        note32: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note33: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
};
export default Form053TC;
